import React from "react";
import { Warning, CheckCircle } from "@phosphor-icons/react";

/**
 * EnvironmentBadge — tells the team which environment they're on so nobody
 * accidentally cadastres products on preview (separate database = lost work).
 *
 * - Production domain(s): subtle green "PRODUÇÃO" badge
 * - Preview / Emergent domains: loud red pulsing "PREVIEW — AMBIENTE DE TESTES"
 * - Localhost: neutral orange "LOCAL"
 */
const PROD_HOSTS = new Set([
  "livesdesapeguecomherida.com.br",
  "www.livesdesapeguecomherida.com.br",
]);

export default function EnvironmentBadge() {
  if (typeof window === "undefined") return null;
  const host = window.location.hostname;
  const isProd = PROD_HOSTS.has(host);
  const isPreview = host.endsWith(".emergentagent.com") || host.endsWith(".emergent.host");
  const isLocal = host === "localhost" || host === "127.0.0.1";

  if (isProd) {
    return (
      <div
        data-testid="env-badge-prod"
        title="Você está no ambiente oficial da loja. Dados vão para o banco de produção."
        className="hidden md:inline-flex items-center gap-1.5 px-2.5 h-7 border-2 border-brand-ink bg-emerald-100 text-emerald-900 font-bold text-[11px] uppercase tracking-wider"
      >
        <CheckCircle weight="bold" size={14} />
        Produção
      </div>
    );
  }

  if (isPreview) {
    return (
      <div
        data-testid="env-badge-preview"
        title="ATENÇÃO: ambiente de testes. Qualquer cadastro feito aqui não aparece em livesdesapeguecomherida.com.br."
        className="inline-flex items-center gap-1.5 px-2.5 h-7 border-2 border-brand-ink bg-red-600 text-white font-bold text-[11px] uppercase tracking-wider animate-pulse shadow-brutalSm"
      >
        <Warning weight="fill" size={14} />
        Preview — teste
      </div>
    );
  }

  if (isLocal) {
    return (
      <div
        data-testid="env-badge-local"
        className="hidden md:inline-flex items-center gap-1.5 px-2.5 h-7 border-2 border-brand-ink bg-orange-200 text-orange-900 font-bold text-[11px] uppercase tracking-wider"
      >
        Local
      </div>
    );
  }

  return null;
}
